import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import * as moment from 'moment';
import { AppConfigService } from '../../app-config.service';

@Pipe({
  name: 'textualDate',
  standalone: false
})
export class TextualDatePipe implements PipeTransform {
  private readonly EN_FORMAT = 'MMMM D[,] YYYY [at] h[:00] a';
  private readonly FR_FORMAT = 'D MMMM YYYY[,] H [h]';

  constructor(private readonly _appConfigService: AppConfigService) {}

  transform(
    date: string | Date,
    langue: string = get(this._appConfigService, 'configData.contexteEnvironnement.langue', 'fr')
  ): any {
    moment.locale(langue);
    let text = moment(date).format(langue === 'fr' ? this.FR_FORMAT : this.EN_FORMAT);

    if (langue === 'en') {
      text = text.replace('am', 'a.m.').replace('pm', 'p.m.');
    }

    return text;
  }
}
